import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const ROLES_API_PATH = '/api/roles';

const getRoles = async () => {
  const response = await axios.get(`${API_BASE_URL}${ROLES_API_PATH}`);
  return response.data.data;
};

const getPermissions = async () => {
  const response = await axios.get(`${API_BASE_URL}${ROLES_API_PATH}/permissions`);
  return response.data.data;
};

const createRole = async (roleData) => {
  const response = await axios.post(`${API_BASE_URL}${ROLES_API_PATH}`, roleData);
  return response.data.data;
};

const updateRole = async (id, roleData) => {
  const response = await axios.put(`${API_BASE_URL}${ROLES_API_PATH}/${id}`, roleData);
  return response.data.data;
};

const roleService = { getRoles, getPermissions, createRole, updateRole };
export default roleService;